import {Navigate} from 'react-router-dom'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {useRef, useState} from 'react'
import {ListComponent} from '../../../parts/crud/List'
import {ActionType, ColumnType, DefaultMenuActions} from '../../../parts/crud/Types'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {processGet, processPatch} from '../../../../services/api'

import {ButtonType, CustomModal} from '../../../parts/components/CustomModal'
import {AccessModal} from './modals/AccessModal'

const MySwal = withReactContent(Swal)
export const TenantsList = () => {
  const childRef = useRef<any>(null)
  const modalRef = useRef<any>(null)
  const [selectedUserId, setSelectedUserId] = useState(0)
  const [groupId, setGroupId] = useState(0)
  const [redirect, setRedirect] = useState('')
  const [groupName, setGroupName] = useState('')
  const [groupKey, setGroupKey] = useState('')
  const [accessId, setAccessId] = useState(0)
  let actions: ActionType[] = [
    {
      title: 'Modifica',
      type: 'link',
      action: 'edit',
      icon: 'fa-solid fa-pencil',
    },
    {
      title: 'Accedi',
      type: 'link',
      action: 'access',
      icon: 'fa-solid fa-right-to-bracket',
    },
    {
      type: 'divider',
    },
    {
      title: 'Disabilita',
      type: 'link',
      action: 'disable',
      icon: 'fa-solid fa-circle-xmark',
      textColor: 'warning',
      condition: (item: any) => item.enabled,
    },
    {
      title: 'Abilita',
      type: 'link',
      action: 'enable',
      textColor: 'success',
      icon: 'fa-solid fa-circle-check',
      condition: (item: any) => !item.enabled,
    },
    {
      title: 'Elimina',
      type: 'link',
      action: 'delete',
      textColor: 'danger',
      icon: 'fa-solid fa-trash',
    },
  ]

  const columns: Array<ColumnType> = [
    {title: 'Chiave', key: 'group_key', type: 'text', orderable: true},
    {title: 'Nome', key: 'group_name', type: 'text', orderable: true},
    {title: 'DBMS Host', key: 'db_host', type: 'text', orderable: true},
    {
      title: 'Attivo',
      key: 'enabled',
      type: 'custom',
      orderable: true,
      render: (data) => {
        return (
          <>
            {data.enabled ? (
              <i className='fa-solid fa-circle-check text-success fs-2'></i>
            ) : (
              <i className='fa-solid fa-circle-xmark text-danger fs-2'></i>
            )}
          </>
        )
      },
    },
  ]

  const disable = (id: string) => {
    MySwal.fire({
      title: 'Disabilita tenant',
      text: 'Sei sicuro di voler disabilitare questo tenant?',

      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sì, disabilita',
      cancelButtonText: 'No, annulla',
    }).then(async (response: any) => {
      if (response.value) {
        await processPatch(`tenants/${id}/disable`)
        if (childRef.current) {
          childRef.current.forceReload()
        }
      }
    })
  }

  const enable = (id: string) => {
    MySwal.fire({
      title: 'Abilita tenant',
      text: 'Sei sicuro di voler abilitare questo tenant?',

      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sì, abilita',
      cancelButtonText: 'No, annulla',
    }).then(async (response: any) => {
      if (response.value) {
        await processPatch(`tenants/${id}/enable`)
        if (childRef.current) {
          childRef.current.forceReload()
        }
      }
    })
  }

  const accedi = async (id: number) => {
    setSelectedUserId(0)
    let tenant: any = await processGet('tenants/' + id)
    setGroupName(tenant.data.group_name)
    setGroupKey(tenant.data.group_key)
    setGroupId(id)
    modalRef.current.open()
  }

  const modal = () => {
    let title = `Accedi al tenant ${groupName} (${groupKey})`
    let buttons: Array<ButtonType> = [
      {
        title: 'Accedi',
        color: 'primary',
        action: async () => {
          if (selectedUserId == 0) {
            return
          }
          let result: any = await processGet(`tenants/${groupId}/access/${selectedUserId}`)
          if (result.success == 1) {
            window.open(result.data.url, '_blank')
            modalRef.current.close()
            MySwal.fire({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer
                toast.onmouseleave = Swal.resumeTimer
              },
              icon: 'success',
              title: 'Accesso effettuato con successo',
            })
          }
        },
      },
    ]

    return (
      <>
        <CustomModal title={title} buttons={buttons} ref={modalRef} id='modal_access'>
          <AccessModal
            id={accessId}
            onSelect={(e) => {
              setSelectedUserId(e.target.value)
            }}
          ></AccessModal>
        </CustomModal>
      </>
    )
  }

  return (
    <>
      {redirect !== '' ? <Navigate to={redirect}></Navigate> : <></>}

      {modal()}
      <CrudProvider api='tenants'>
        <ListComponent
          ref={childRef}
          menuClicked={async (action, data) => {
            console.log(action)
            if (action === 'disable') {
              disable(data.id)
              return false
            }
            if (action === 'enable') {
              enable(data.id)
              return false
            }

            if (action === 'access') {
              setAccessId(data.id)
              await accedi(data.id)

              return false
            }
            return true
          }}
          defOrderDir='ASC'
          defOrder='group_name'
          columns={columns}
          actions={actions}
          title_delete='Eliminazione tenant'
          text_eliminare="Sei sicuro di voler eliminare questo tenant?L'operazione non è reversibile"
          text_eliminato='tenant eliminato con successo'
          text_nuovo='Nuovo tenant'
        ></ListComponent>
      </CrudProvider>
    </>
  )
}
